/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var DataChartTrendXyUpIcon64Regular = forwardRef('DataChartTrendXyUpIcon64Regular', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 64 }, props),
        React.createElement("path", { d: "M9 9.5a1.5 1.5 0 1 0-3 0v39a8.5 8.5 0 0 0 8.5 8.5h42a1.5 1.5 0 0 0 0-3h-42A5.5 5.5 0 0 1 9 48.5v-39Z" }),
        React.createElement("path", { d: "M55.56 20.06a1.5 1.5 0 0 0-2.12-2.12L37 34.378l-7.555-7.556a2.75 2.75 0 0 0-3.89 0L15.94 36.44a1.5 1.5 0 0 0 2.122 2.122l9.439-9.44 7.556 7.556a2.75 2.75 0 0 0 3.889 0L55.56 20.06Z" })));
});
